var map = {
	"./contest/2021/1028.jpg": "14b3",
	"./contest/2021/1107.jpg": "9dbd",
	"./contest/2021/1115.jpg": "26ca",
	"./contest/2021/1135.jpg": "4b03",
	"./contest/2021/1272.jpg": "ace1",
	"./contest/2021/1273.jpg": "54b2",
	"./contest/2021/1383.jpg": "b794",
	"./contest/2021/164.jpg": "ce54",
	"./contest/2021/1995.jpg": "4b78",
	"./contest/2021/2006.jpg": "33e9",
	"./contest/2021/2303.jpg": "eb5c",
	"./contest/2021/2471.jpg": "9b2a",
	"./contest/2021/2723.jpg": "f61d",
	"./contest/2021/2728.jpg": "0448",
	"./contest/2021/2812.jpg": "956b",
	"./contest/2021/4263.jpg": "773b",
	"./contest/2021/4631.jpg": "7a11",
	"./contest/2021/4664.jpg": "3fd3",
	"./contest/2021/515.jpg": "11d7",
	"./contest/2021/814.jpg": "f120",
	"./contest/2022/1029.jpg": "491f",
	"./contest/2022/111.jpg": "9a57",
	"./contest/2022/1158.jpg": "91e2",
	"./contest/2022/1230.jpg": "074e",
	"./contest/2022/1364.jpg": "930c",
	"./contest/2022/138.jpg": "5507",
	"./contest/2022/1501.jpg": "ca3f",
	"./contest/2022/1876.jpg": "a68f",
	"./contest/2022/2027.jpg": "a24d",
	"./contest/2022/2057.jpg": "dbd5",
	"./contest/2022/2303.jpg": "26d6",
	"./contest/2022/2304.jpg": "bcf6",
	"./contest/2022/2470.jpg": "6410",
	"./contest/2022/2471.jpg": "fe64",
	"./contest/2022/2479.jpg": "cde8",
	"./contest/2022/2622.jpg": "b9bc",
	"./contest/2022/2812.jpg": "c443",
	"./contest/2022/319.jpg": "8c1f",
	"./contest/2022/376.jpg": "baaa",
	"./contest/2022/3924.jpg": "b413",
	"./contest/2022/4051.jpg": "f978",
	"./contest/2022/4499.jpg": "3175",
	"./contest/2022/4590.jpg": "e652",
	"./contest/2022/4631.jpg": "ec30",
	"./contest/2022/4635.jpg": "8694",
	"./contest/2022/4681.jpg": "32f5",
	"./contest/2022/4684.jpg": "5df7",
	"./contest/2022/4785.jpg": "55ca",
	"./contest/2022/4967.jpg": "7b7a",
	"./contest/2022/4972.jpg": "a303",
	"./contest/2022/4992.jpg": "41aa",
	"./contest/2022/5054.jpg": "a77f",
	"./contest/2022/5129.jpg": "790a",
	"./contest/2022/5273.jpg": "17c4",
	"./contest/2022/5276.jpg": "dc53",
	"./contest/2022/5277.jpg": "bc9e",
	"./contest/2022/5278.jpg": "7c28",
	"./contest/2022/5351.jpg": "d014",
	"./contest/2022/597.jpg": "b4d3",
	"./contest/2022/8121.jpg": "bb5a",
	"./contest/2022/8445.jpg": "98a9",
	"./contest/2022/8567.jpg": "17d3",
	"./contest/2022/8923.jpg": "05fd",
	"./contest/2022/938.jpg": "af35",
	"./contest/2022/944.jpg": "fc15",
	"./contest/2022/958.jpg": "79bb",
	"./contest/2022/960.jpg": "5109",
	"./contest/2022/981.jpg": "a651",
	"./contest/2022/9999.jpg": "183b",
	"./contest/2023/1005.jpg": "5db2",
	"./contest/2023/1009.jpg": "6b89",
	"./contest/2023/1876.jpg": "df77",
	"./contest/2023/1965.jpg": "2833",
	"./contest/2023/2473.jpg": "14e8",
	"./contest/2023/2658.jpg": "c244",
	"./contest/2023/314.jpg": "a322",
	"./contest/2023/4680.jpg": "024c",
	"./contest/2023/4816.jpg": "9eac",
	"./contest/2023/4817.jpg": "dbe7",
	"./contest/2023/494.jpg": "a552",
	"./contest/2023/5129.jpg": "e852",
	"./contest/2023/5444.jpg": "b2ac",
	"./contest/2023/5448.jpg": "ecd1",
	"./contest/2023/5458.jpg": "33c3",
	"./contest/2023/5550.jpg": "3e95",
	"./contest/2023/5562.jpg": "1137",
	"./contest/2023/5581.jpg": "353f",
	"./contest/2023/5656.jpg": "cf94",
	"./contest/2023/646.jpg": "77c0",
	"./contest/2024/155615.jpg": "907b",
	"./contest/2024/155615.png": "5a55",
	"./contest/2024/160394.png": "459a",
	"./contest/2024/163143.jpg": "11ca",
	"./contest/2024/163144.jpg": "8bd6",
	"./contest/2024/163483.jpg": "211a",
	"./contest/2024/165201.jpg": "b79d",
	"./contest/2024/168193.jpg": "bef7",
	"./contest/2024/168197.jpg": "7de1",
	"./contest/2024/16849.png": "860b",
	"./contest/2024/190558.jpg": "8948",
	"./contest/2024/190566.jpg": "a9a2",
	"./contest/2024/198643.jpg": "08cb",
	"./contest/2024/198646.png": "d928",
	"./contest/2024/223752.jpg": "9d77",
	"./contest/2024/45659.jpg": "0f18",
	"./contest/2024/475683.png": "9677",
	"./contest/2024/550492.jpg": "a57a",
	"./contest/2024/8312.jpg": "ee29",
	"./contest/2024/8405.jpg": "6668",
	"./contest/2024/8501.jpg": "b147",
	"./contest/2025/162005.jpg": "9ef9",
	"./contest/2025/162013.jpg": "74a1",
	"./contest/2025/162018.jpg": "ec24",
	"./contest/2025/162084.jpg": "1f3f",
	"./contest/2025/162099.jpg": "0920",
	"./contest/2025/162100.jpg": "8db3",
	"./contest/2025/162117.jpg": "a6b6",
	"./contest/2025/163144.jpg": "2c70",
	"./contest/2025/170077.jpg": "8617",
	"./contest/2025/170103.jpg": "bf34",
	"./contest/2025/464071.jpg": "cf56",
	"./contest/2025/464077.jpg": "2bff",
	"./contest/2025/59542.jpg": "d47c",
	"./contest/2025/746888.jpg": "d04e",
	"./contest/2025/746895.jpg": "e198",
	"./contest/2025/746896.jpg": "0db7",
	"./contest/2025/747405.jpg": "8bf6",
	"./contest/2025/751344.jpg": "78f3",
	"./contest/2025/92480.jpg": "68f1",
	"./contest/2025/92506.jpg": "1dc3",
	"./contest/2026/160379.jpg": "7b90",
	"./contest/2026/160380.jpg": "cf2e",
	"./contest/2026/162005.jpg": "70b9",
	"./contest/2026/162014.jpg": "a15f",
	"./contest/2026/162018.jpg": "8456",
	"./contest/2026/162085.jpg": "a4a4",
	"./contest/2026/162100.jpg": "d1ed",
	"./contest/2026/165201.jpg": "5c2c",
	"./contest/2026/588698.jpg": "3416",
	"./contest/2026/732603.jpg": "b41b",
	"./contest/2026/732617.jpg": "e567",
	"./contest/2026/79578.jpg": "3457",
	"./contest/2026/836221.jpg": "86d3",
	"./contest/2026/836226.jpg": "8859",
	"./contest/2026/836230.jpg": "ed91",
	"./contest/2026/836233.jpg": "8d25",
	"./contest/2026/836235.jpg": "8c0e",
	"./contest/2026/850251.jpg": "ff76",
	"./contest/2026/859587.jpg": "301d",
	"./contest/2026/92506.jpg": "c16a",
	"./dem/bottone-partecipa.jpg": "1806",
	"./dem/date.png": "e882",
	"./dem/header.png": "3ea7",
	"./header/2021/mb-visual-background.png": "0965",
	"./header/2022/mb-visual-background.png": "028f",
	"./header/2023/mb-visual-background.png": "0320",
	"./header/2024/mb-visual-background.jpg": "431f",
	"./header/base/cards.png": "1de4",
	"./header/base/mb-visual-background.png": "0127",
	"./header/base/visore.png": "d100",
	"./header/base/visore_2025.png": "2ce6",
	"./header/base/visore_fiori_2025.png": "fa33",
	"./sections/box-ape.png": "5108",
	"./sections/box-aziende.png": "2bbc",
	"./sections/box-biscotti.png": "578b",
	"./sections/box-farina.png": "77b2",
	"./sections/box-fiori.png": "de90",
	"./sections/box-mulino.png": "c694",
	"./sections/contest-2026.png": "29ba",
	"./sections/contest.png": "dbb6",
	"./sections/exhibeetion.png": "9957",
	"./sections/logo-farina-sostenibile.png": "75bd",
	"./sections/mb-nuovo-logo.png": "711c",
	"./sections/pov-agricoltori.png": "f759",
	"./sections/pov-api.png": "5162",
	"./sections/pov-brahmino.png": "9285"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";